export const MON_CMS_OPTIONS = {
    ADMIN: '_admin',
    EDITOR: '_edit',
    ORIGINAL: 'original',
    ALTERNATIVE: 'alternative',
    STANDARD: 'standard',
} as const;
